import React from "react";
import PisosPaso4 from "../../components/CotizacionHogar/CotizacionProteccionesPaso3";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

class ContainerCotizacionPaso3 extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {    
    return (
      <main className="bg-light">
        <div className="cr-content container-fluid">
          <div className="container-body-spaces">                    
            <PisosPaso4/>
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = state => ({  
});

const mapDispatchToProps = dispatch => {
  return {
    
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ContainerCotizacionPaso3)
);
